import { detect } from "detect-browser";
const browser = detect();

// HERO BROWSER SUPPORT
const supported = [
  "chrome",
  "edge-chromium",
  "safari",
  "firefox",
  "ios",
  "crios",
  "fxios",
];
export const browserSupported = supported.includes(browser.name);

// DEVICE / PLATFORM
export let platform;
if (browser.os.toLowerCase().includes("ios")) {
  platform = "ios";
} else if (browser.os.toLowerCase().includes("android")) {
  platform = "android";
} else {
  // assume desktop
  platform = "desktop";
}
